<template>
  <v-container>
    <v-row v-if="training">
      <v-col cols="12" md="9">
        <div class="iframe-container">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/vWv8FAIocmQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <div class="iframe-container">
          <iframe src="https://www.youtube.com/live_chat?v=vWv8FAIocmQ&amp;embed_domain=training.teamculture.com.br"></iframe>
        </div>
      </v-col>

    </v-row>

    <v-row v-if="gifts">
      <v-col v-for="gift in gifts" :key="gift.id" cols="12" sm="6" md="4" lg="3">
        <v-card class="mx-auto" tile max-width="600">
          <v-img
            class="white--text align-end"
            height="200px"
            :src="gift.img"
          ></v-img>
          <v-card-title><p class="subtitle-2">{{ gift.title }}</p></v-card-title>
          <v-card-actions>
            <v-btn color="primary" :href="gift.link" target="_blank" text>Acessar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebaseApp from '@/firebase/init'

export default {
  name: 'Training',
  data () {
    return {
      training: null,
      gifts: []
    }
  },
  created () {
    const db = firebaseApp.firestore()
    db.collection('trainings').doc(this.$route.params.id).get().then(doc => {
      if (!doc.exists) {
        this.$router.push({ 'name': 'MyTrainings' })
      }

      this.training = { id: doc.id, ...doc.data() }

      db.collection('gifts').orderBy('priority').get().then(snapshot => {
        snapshot.forEach(doc => {
          this.gifts.push({ id: doc.id, ...doc.data() })
        })
      })
    })
  }
}
</script>

<style>
.iframe-container{
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 56.25%;
}
.iframe-container iframe{
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
